import { createContext, useContext } from "react";
import { getEmpresaIdLogada } from "../utils/getEmpresaLogada";
import { obterStorage } from "../utils/secureStorage";

export const ShortcutsContext = createContext({});

const gerarRedirect = async () => {
  try {
    const dadosAuth = obterStorage("_da");
    if (!dadosAuth) {
      console.error("Usuário não está logado");
      return null;
    }

    const { tokenDTO } = dadosAuth;
    const idEmpresa = getEmpresaIdLogada();

    if (!tokenDTO?.token) {
      console.error("Token não encontrado");
      return null;
    }

    const baseURL = process.env.REACT_APP_BASE_URL_API || "http://localhost:8081/";
    const response = await fetch(
      `${baseURL}usuario-sessao/redirect/gerar?url=https://chat.waybe.com.br`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tokenDTO.token}`,
          "Content-Type": "application/json",
          ...(idEmpresa && { "X-IdEmpresa": idEmpresa }),
        },
      },
    );

    if (response.ok) {
      const data = await response.json();
      return data.token;
    } else {
      console.error(" Erro na API:", response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error(" Erro ao gerar redirect:", error);
    return null;
  }
};

export const ShortcutsProvider = ({ children }) => {
  const handleChatbotClick = async () => {
    const redirectUrl = await gerarRedirect();
    if (redirectUrl) {
      window.open(redirectUrl, "_blank");
    } else {
      console.error(" Falha ao gerar redirect");
      window.open("https://chat.waybe.com.br", "_blank");
    }
  };

  const value = {
    shortcutsActive: true,
    handleChatbotClick,
  };

  return <ShortcutsContext.Provider value={value}>{children}</ShortcutsContext.Provider>;
};

export const useShortcuts = () => useContext(ShortcutsContext);
